// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yInOr","secondarySidebar":"styles_secondarySidebar__ZZln7","navLink":"styles_navLink__3RdF7","content":"styles_content__tMIvC"};